import { default as Table } from './Table';

export default Table;
